<script setup lang="ts">
import { computed, useSlots, type Slots } from "vue";
import type { II18nTranslateProps } from "./props";

const props = defineProps<II18nTranslateProps>();
const slots = useSlots() as Slots;

const tag = computed(() => {
  return props.tag ?? "span";
});
</script>

<template>
  <i18n-t :keypath="props.keypath" :tag="tag" scope="global">
    <template v-for="(slot, name) in slots" #[name]>
      <slot :name="name"></slot>
    </template>
  </i18n-t>
</template>
